<script>
  export let methodology;
</script>

<style lang="scss">
  .footnotes {
    max-width: 800px;
    margin: 0 auto;
    padding: 1.5rem;
  }

  h4 {
    font-size: 1.6rem;
    margin: 1.5rem 0 1rem 0;

    & a {
      text-decoration: none;
      border-bottom: 1px dotted var(--cl-ippd);
      color: var(--cl-ippd);
    }
  }

  p {
    font-size: 1.3rem;
  }
</style>

<div class="footnotes">
  {#each methodology as m}
    <h4 id="methodology">
      <a
        href="https://drive.google.com/file/d/1An7iE64RXXC3cYbX1gWfg-y98MSv8_Au/view?usp=sharing"
        target="_blank">
        {m.method}
      </a>
    </h4>
    <p>{m.description}</p>
  {/each}
</div>
